import {
  createPODAttachmentsForVehicleTrackingApi,
  createVehicleLocationLogsApi,
  getVehicleListApi,
  getVehicleLocationLogsApi,
  getPODAttachmentsForVehicleTrackingApi,
} from 'src/api/vehicle';
import {
  CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  CREATE_VEHICLE_LOCATION_LOGS,
  GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  GET_VEHICLE_LIST,
  GET_VEHICLE_LOCATION_LOGS,
  RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  RESET_VEHICLE_LOCATION_LOGS,
} from 'src/redux/Actions/Type';

export function getVehicleList(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getVehicleListApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_LIST,
        payload: data,
      });
      return data;
    });
}

export function getVehicleLocationLogs(
  tenantOrganisationId,
  vehicleId,
  filters = {},
) {
  return (dispatch) =>
    getVehicleLocationLogsApi(tenantOrganisationId, vehicleId, filters).then(
      (data) => {
        dispatch({
          type: GET_VEHICLE_LOCATION_LOGS,
          payload: data,
        });
        return data;
      },
    );
}

export const createVehicleLocationLogs = (createData) => (dispatch) =>
  createVehicleLocationLogsApi(createData).then((data) => {
    dispatch({
      type: CREATE_VEHICLE_LOCATION_LOGS,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const createPODAttachmentsForVehicleTracking =
  (formData) => (dispatch) =>
    createPODAttachmentsForVehicleTrackingApi(formData).then((data) => {
      dispatch({
        type: CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });

export function getPODAttachmentsForVehicleTracking(vehicleTrackingNumber) {
  return (dispatch) =>
    getPODAttachmentsForVehicleTrackingApi(vehicleTrackingNumber).then(
      (data) => {
        dispatch({
          type: GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
          payload: data,
        });
        return data;
      },
    );
}

export const resetVehicleLocationLogs = () => ({
  type: RESET_VEHICLE_LOCATION_LOGS,
});

export const resetPODAttachmentsForVehicleTracking = () => ({
  type: RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
});
